import React, { useEffect, useState } from "react";

import { IconCheck } from "../icons";
import "./BaseCheckboxInput.scss";

function BaseCheckboxInput({
  value,
  label = "",
  trueValue = true,
  onChange = null,
  falseValue = false,
  checkIcon = null,
  disabled = false,
  "aria-label": ariaLabel = undefined,
  ...props
}) {
  const [isChecked, setChecked] = useState(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  function updateInput(event) {
    const checked = event.target.checked;
    const checkValue = checked ? trueValue : falseValue;
    setChecked(checkValue);
    onChange && onChange(checkValue);
  }
  return (
    <div
      {...props}
      title={props.title}
      className={`checkbox-input  inline-flex items-center ${
        disabled ? "disabled" : ""
      } ${isChecked ? "checked" : ""} ${props.className}`}>
      <span
        className={`checkbox flex flex-centered ${checkIcon ? "negate" : ""} ${
          disabled ? "disabled" : ""
        }`}>
        {checkIcon == null ? <IconCheck /> : checkIcon}
      </span>

      {!!label && <label className="checkbox-label">{label}</label>}

      <input
        className="input absolute-center fill"
        type="checkbox"
        disabled={disabled}
        aria-label={ariaLabel}
        // Follows the drawn tick: a defaultChecked box kept its first state when a
        // reused legend row's value changed, so a click on a ticked row ticked it again.
        checked={!!isChecked}
        onChange={updateInput}
      />
    </div>
  );
}

export default BaseCheckboxInput;
